<template>
    <div id="banner-basicas text-center">
        <div class="banner-content">
            <picture v-if="topBanner.desktop_image && topBanner.mobile_image">
                <source
                    :srcset="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${topBanner.desktop_image}?auto=compress,format&q=65`"
                    media="(min-width: 576px)"
                />
                <img
                    :src="`${$scope.CDN_IMAGES}/images/site/colecoes-basicas/imgs/${topBanner.mobile_image}?auto=compress,format&q=65`"
                    alt="Coleções Básicas"
                    class="img-responsive center-block"
                />
            </picture>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BannerBasicas',

        props: {
            topBanner: {
                type: Object,
                required: true,
            },
        },
    };
</script>
